<div [class]="className">
  <div class="detail-popup-desktop">
    <div class="modal-title">{{ title }}</div>
    <a (click)="dimiss()">
      <img src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/cancel-close.svg" alt="close-bg" height="auto"
        width="auto">
    </a>
    <div class="modal-body">
      <button *ngFor="let item of dataIn" [ngClass]="{'main-button' : item.key === 'MODEM'}" (click)="selectButton(item)">{{
        item.text }}</button>
    </div>
  </div>
  <div class="detail-popup-mobile">
    <a class="handle"(click)="dimiss()">x</a>
    <div class="content">
      <span class="title">Xem chi tiết giao dịch</span>
    </div>
    <div class="info">
      <button *ngFor="let item of dataIn" [ngClass]="{'main-button' : item.key === 'MODEM'}"
         (click)="selectButton(item)">{{item.text}}</button>
    </div>
  </div>
</div>
